import { createEnv } from 'valibot-env/nextjs';
import * as v from 'valibot';

export const env = createEnv({
  schema: {
    public: {
      NEXT_PUBLIC_DEPLOYABLE_ENV: v.fallback(
        v.pipe(
          v.picklist(['prod', 'production', 'stage', 'local', 'dev']),
          v.transform(val => {
            if (val === 'local') {
              return 'dev';
            }
            if (val === 'production') {
              return 'prod';
            }
            return val;
          }),
        ),
        'prod',
      ),
    },
    private: {
      LOG_LEVEL: v.fallback(
        v.picklist(['fatal', 'error', 'warn', 'info', 'debug', 'trace', 'silent']),
        'info',
      ),
    },
  },
  values: {
    LOG_LEVEL: process.env.LOG_LEVEL,
    NEXT_PUBLIC_DEPLOYABLE_ENV: process.env.NEXT_PUBLIC_DEPLOYABLE_ENV,
  },
});
